export default __webpack_public_path__ + "static/media/photo--sm--misc-15.04d408c2.jpg";